



















































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import TitleArea from '@/components/TitleArea.vue';
import { getAllUtentesServer, UtenteTotalCards } from '@/plugins/utils/utentesUtils';
import { checkDoc, checkRecepcao, copyArrayJson, GenerateFriendlyName } from '@/plugins/utils/utils';

@Component({
  components: {
    TitleArea
  }
})
export default class Utentes extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers: Array<any> = [
    {
      text: "Nome",
      align: 'start',
      sortable: true,
      value: 'nome',
    },
    {
      text: "Código",
      align: 'start',
      sortable: true,
      value: 'codigo',
    },
    {
      text: "Telefone",
      align: 'start',
      sortable: true,
      value: 'telefone',
    },
    {
      text: "+Info",
      align: 'center',
      sortable: true,
      value: 'info',
    },
  ];
  
  get itensPage(): number {
    if( !(this.$store.getters.userData && this.$store.getters.userData.itens_pag) ){
      return 10;
    }
    else{
      return this.$store.getters.userData.itens_pag;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  footerOptions: any = {
    "items-per-page-options": [this.itensPage, -1],
    "items-per-page-text": "Linhas/página",
    "items-per-page-all-text": "Todos"
  } 
  search = "";
  utentesList: UtenteTotalCards[] = [];
  utentes_loading = false;
  errorUtentes = false;

  get utentesListSearc(): UtenteTotalCards[]{
    return this.utentesList.filter(item => {
      if(!this.search || this.search.length < 3){
        return true;
      }
      else {
        const key_array: string[] = this.search.trim().split(" ");
        // console.log(key_array);
        let flag_found = 0;
        key_array.forEach(value => {
          const new_value: string = GenerateFriendlyName(value);
          if(!item.nome_pesquisa){
            item.nome_pesquisa = GenerateFriendlyName(item.nome);
          }
          if(!item.diagnosticos_pesquisa && item.diagnosticos){
            item.diagnosticos_pesquisa = GenerateFriendlyName(item.diagnosticos);
          }
          
          if(
            (item.nome_pesquisa && item.nome_pesquisa.includes(new_value)) ||
            (item.codigo && item.codigo == value) || 
            (item.diagnosticos_pesquisa && item.diagnosticos_pesquisa.includes(new_value) ) || 
            (item.telefone && item.telefone.includes(value))
          ){
            flag_found++;
          }

        });

        if(flag_found > 0 && flag_found == key_array.length){
          return true;
        }
        else {
          return false;
        }
      }
    });
  }
  
  created() {
    this.utentes_loading = true;
    this.errorUtentes = false;
    this.utentesList = [];
    getAllUtentesServer(
      (utentes: UtenteTotalCards[]) => {
        // console.log("u",utentes)
        this.utentesList = copyArrayJson(utentes);
        this.utentes_loading = false;
        this.$store.commit("setLoading", false);
      },
      () => {
        this.utentes_loading = false;
        this.$store.commit("setLoading", false);
        // console.log("err",code);
      }
    )
  }

  get checkRecepcao(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel)
      return checkRecepcao(this.$store.getters.userData.nivel);
    else
      return false;
  }
  get checkDoc(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel)
      return checkDoc(this.$store.getters.userData.nivel);
    else
      return false;
  }
}
